import { render, staticRenderFns } from "./SharedPlanner.vue?vue&type=template&id=b0ea1794"
import script from "./SharedPlanner.vue?vue&type=script&lang=js"
export * from "./SharedPlanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0ea1794')) {
      api.createRecord('b0ea1794', component.options)
    } else {
      api.reload('b0ea1794', component.options)
    }
    module.hot.accept("./SharedPlanner.vue?vue&type=template&id=b0ea1794", function () {
      api.rerender('b0ea1794', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/section/SharedPlanner.vue"
export default component.exports